<template>
  <div class="relative">
    <div class="ogray-backdrop hidden lg:block mb-5 md:mb-0 rounded-b-lg left-0 right-0 mx-auto absolute rounded-t-md bg-gray-50 lg:h-64 max-h-full max-w-full" />
    <div class="container-fluid lg:container">
      <div class="osignup-box-container lg:pb-15">
        <div class="flex flex-col relative overflow-hidden bg-white lg:shadow-lg lg:rounded-lg">
          <div class="lg:flex-1 lg:flex lg:flex-col">
            <div class="lg:flex lg:flex-1">
              <div
                class="left-flex"
                :class="{ 'left-flex-max-w': hasSecondaryContentSlot }"
              >
                <Steps v-if="!hideSteps" class="hidden lg:flex" :active-step="activeStep" :steps="steps" :class="classes" />
                <slot />
              </div>
              <div v-if="hasSecondaryContentSlot" class="hidden right-flex rounded-br-lg rounded-tr-lg overflow-x-hidden lg:block" :style="{ 'background-color': backgroundColor }">
                <slot name="secondary-content" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { props } from '@/components/Steps/Steps'
const Steps = () => import('@/components/Steps/Steps')
export default {
  name: 'SignUpLayoutBox',
  components: {
    Steps
  },
  props: {
    backgroundColor: {
      type: String,
      required: false,
      default: 'transparent'
    },
    hideSteps: {
      type: Boolean,
      required: false,
      default: true
    },
    classes: {
      type: Array,
      default: () => ([])
    },
    ...props
  },
  computed: {
    hasSecondaryContentSlot () {
      return !!this.$slots['secondary-content']
    }
  }
}
</script>

<style lang="postcss" scoped>
@screen lg {
  .left-flex {
    flex: 66;
  }

  .left-flex-max-w {
    max-width: 66%;
  }

  .right-flex {
    flex: 34;
  }

  .ogray-backdrop {
    width: 125.4rem;
    height: 50rem;
  }

  .osignup-box-container {
    min-height: 58rem;

    > div {
      top: 6.1rem;
    }
  }
}
</style>
